import { render, staticRenderFns } from "./EstateAgentContactPerson.vue?vue&type=template&id=63618570"
import script from "./EstateAgentContactPerson.vue?vue&type=script&lang=js"
export * from "./EstateAgentContactPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports